import { Box, Chip, FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function FormSelectMultipleTags<T extends FieldValues>({
    control,
    disabled,
    fullWidth,
    helperText,
    label,
    options,
    required,
    small,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <FormControl fullWidth>
            <Controller
                control={control}
                name={value}
                render={({ field: { onBlur, onChange, ref, value: inputValue }, fieldState: { error } }) => (
                    <>
                        <Typography sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</Typography>
                        <Select
                            disabled={disabled}
                            error={error?.message ? true : false}
                            fullWidth={fullWidth}
                            MenuProps={MenuProps}
                            multiple
                            onBlur={onBlur}
                            onChange={onChange}
                            ref={ref}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip
                                            key={value}
                                            label={options?.find((option) => option.value === value)?.label || value}
                                            sx={{
                                                bgcolor: options?.find((option) => option.value === value)?.color,
                                            }}
                                        />
                                    ))}
                                </Box>
                            )}
                            size={small ? 'small' : 'medium'}
                            sx={{ width: fullWidth ? undefined : 250 }}
                            value={inputValue ?? []}
                        >
                            {options?.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText sx={{ color: error?.message ? 'error.main' : undefined }}>
                            {error?.message ?? helperText}
                        </FormHelperText>
                    </>
                )}
                rules={{
                    required: required ? `${label ?? value} cannot be empty` : false,
                }}
            />
        </FormControl>
    );
}
